import 'slick-carousel'
import { createApp } from 'vue'
import { isDesktop } from '~/js/templates/index/helpers'
import FButton from '~/js/components/button'
import FModal from '~/js/components/modal'
import FProductCard from '~/js/components/productCard'
import FSlider from '~/js/components/slider'
import { isIndexPage } from '~/js/helpers/page-helper'
import { getItemsFromIds, getRecentProductIds } from '~/js/helpers/getProducts'

const CLASS_NAME = 'js-snippets-recent-items'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  const recentProductIds = getRecentProductIds()
  Array.from(elements).forEach(async (element) => {
    if (!recentProductIds.length) {
      element.remove()
    }

    const max = element.dataset.productCount
    const getProducts = async () => {
      return await getItemsFromIds(recentProductIds.slice(0, max))
    }

    let products = []
    let hasError = false

    try {
      products = await getProducts()
    } catch (_) {
      hasError = true
    }

    createApp({
      name: 'TemplatesIndexRecentProducts',
      components: {
        FButton,
        FModal,
        FProductCard,
        FSlider,
      },
      data() {
        return {
          hasError,
          selectedIndex: 0,
          showReview: !isIndexPage,
          showCartButton: !isIndexPage,
          isDesktop: isDesktop(),
          isProcessing: false,
          products: products.filter((v) => v),
        }
      },
      mounted() {
        window.zvRenderReviewSummary(element)

        // SPの場合に実行、PCでは ComponentSlider で縦幅調整
        if (this.$refs.list) {
          const elementsCard =
            this.$refs.list.querySelectorAll('.c-product-card')
          let maxHeight = 0
          this.$nextTick(() => {
            maxHeight = Array.from(elementsCard).reduce(
              (maxHeight, element) => {
                element.style.height = 'auto'
                return Math.max(element.clientHeight, maxHeight)
              },
              0
            )
          })
          elementsCard.forEach((element) => {
            element.style.height = `${maxHeight}px`
          })
        }
      },
      methods: {
        async getProducts() {
          this.isProcessing = true
          try {
            this.products = await getProducts()
            this.hasError = false
          } catch (e) {
            this.hasError = true
            console.error(e)
          }
          this.isProcessing = false
        },
        onCurrentIndexChanged(index) {
          this.selectedIndex = index
        },
      },
    }).mount(element)
  })
})
